<template>
	<CardGeneric class="text-left paymentInfoComponent">
		<p class="cardTitle">{{ $t("paymentMethodTitle") }}</p>
		<p class="cardSubTitle">{{ $t("paymentMethodSubtitle") }}</p>

		<div class="text-ternary text-center italic py-4">
			{{ $t(`disabledCheckout`) }}
		</div>
	</CardGeneric>
</template>

<script setup></script>

<style scoped></style>
